import React from "react";
import {  useSelector } from "react-redux";
import {  Grid, Label  } from "semantic-ui-react";
import DropDown from "../../../../commonComponents/formComponents/dropDown";
import InputField from "../../../../commonComponents/formComponents/inputField";
import PopUpIcon from "../../../../commonComponents/formComponents/PopUpIcon";
import { TranslateContext } from "../../TranslateContext";
import { wareHouseKey } from "../../../util/NL_fieldPatterns";


const displayError=(value)=>{
  if(!value)
    return null
  return(
    <PopUpIcon style={{"display": "inline"}}
          color="red" icon="exclamation triangle circle"
          popupText={<div className="error">* {value}</div>} 
          />
  )
}
const WarehouseForm=({validateError,fieldPattern,errorInfo:{warehouseIdError},dataSource:{id,type},onUpdate,saveData,displayInfo,disableForm})=>{
  const wareHouseTypeList=useSelector((state) => state.DropDownValues.wareHouseTypes);
  const translate = React.useContext(TranslateContext).translate
 
  
 return (
    <Grid.Row className="theme-textbox">
   
              <label className="label-address">{displayInfo && <PopUpIcon  icon="info circle"
                  popupText={<ul><li>{displayInfo}</li></ul>}></PopUpIcon>
              } 
              {translate("WAREHOUSE_DETAILS", {ns:["default", "header"]})}</label>
              
    
    <Grid.Column className="row" width="8" >
    
      <Label className="disabled title">
        {displayError(warehouseIdError)}
      {translate("WAREHOUSE_ID", {ns:["default", "header"]})}
      </Label>
      <InputField
      
        isLabel={false}
        isFooterLabel={true}
        id="wareHouseId"
        name="wareHouseId"
        type="text"
        clearInput={false}
        onChange={(value)=>onUpdate({id:value})}
        {...disableForm}
        onBlur={(value) =>{
          saveData({id:id || " "})
          validateError({[`${wareHouseKey}`]:""},{transportation:{warehoueDetails:{id}}},{[wareHouseKey]:fieldPattern()?.header[wareHouseKey]})
        }
        }
        value={id}
      />
    </Grid.Column>
   
    <Grid.Column width="8" className="row" >
    <Label className="disabled title">{translate("WAREHOUSE_TYPE", {ns:["default", "header"]})}</Label>
    <DropDown
                id="warehouseType"
                className="field-bg dropdown100 theme-dropdown"
                labelClass="text-none"
                isLabel={false}
                data={wareHouseTypeList}
                {...disableForm}
                value={type}
                clearable
                onChange={(value)=>{
                  onUpdate({type:value})
                  saveData({type:value || ' '})
                }}
                // onBlur={(value) =>saveData({type})}
        />
    
    </Grid.Column>
    
  </Grid.Row>
  );
}
WarehouseForm.defaultProps={
    dataSource:{},
    errorInfo:{},
    disableForm:{}
}
export default React.memo(WarehouseForm)
